import React from "react";

import { useState } from "react";

import { Button } from "@mui/material";

interface props {
  name: string;
  initiallySelected: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FirstRunEmailOption: React.FC<props> = (props) => {
  const [isSelected, setIsSelected] = useState(props.initiallySelected);

  return (
    <Button
      variant={isSelected ? "contained" : "outlined"}
      style={{ margin: 5, backgroundColor: isSelected ? "#00CC99" : "white" }}
      onClick={() => {
        setIsSelected(!isSelected);
        props.onChange({
          target: {
            ...document.createElement("input"),
            name: props.name,
            checked: !isSelected,
          } as HTMLInputElement,
        } as React.ChangeEvent<HTMLInputElement>);
      }}
    >
      {props.name}
    </Button>
  );
};
export default FirstRunEmailOption;
